import { Box, Tabs, Tab, CircularProgress, Button, Typography } from "@mui/material";
import dayjs from "dayjs";
import MStoreCard from "features/searchStore/components/MStoreCard";
import {
  ISearchFilter,
  ISearchRequest,
  IStoreDetailData,
} from "features/searchStore/models";
import {
  selectStores,
  searchStoreActions,
  selectFilter,
  selectByBudgetStores,
  selectLoading,
} from "features/searchStore/saga/searchStoreSlice";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";

export function MListSection() {
  const dispatch = useAppDispatch();

  const storeList = useAppSelector(selectStores);
  const budgetStoreList = useAppSelector(selectByBudgetStores);
  const filter = useAppSelector(selectFilter);
  const isLoading = useAppSelector(selectLoading);

  const handleToggleChange = (e: any, value: number) => {
    const newFilter: ISearchFilter = {
      ...filter,
      sort_code: value,
    };
    dispatch(searchStoreActions.setSearchFilter(newFilter));
  };

  useEffect(() => {
    const entityList: string[] = [];
    let timeStr = "";
    if (filter.area && filter.area.value !== "") {
      entityList.push(filter.area.value);
    }
    if (filter.keyword && filter.keyword?.value !== "") {
      entityList.push(filter.keyword.value);
    }
    if (filter.genres) {
      entityList.push(...filter.genres);
    }
    if (filter.conditions) {
      entityList.push(...filter.conditions);
    }
    if (filter.scenes) {
      entityList.push(...filter.scenes);
    }

    if (filter.date && filter.time && filter.time !== "指定なし") {
      let day = 0;
      const newTime = dayjs(filter.time, "HH:mm")
        .add(30, "minute")
        .format("HH:mm");
      if (filter.date.day() === 0) {
        day = 8;
      } else {
        day = filter.date.day() + 1;
      }
      timeStr = `${day.toString()}-${filter.time}-${newTime}`;
    }

    const req: ISearchRequest = {
      entity_ids: entityList,
      sort_code: filter.sort_code,
      top_n: 10,
      time: timeStr,
    };

    dispatch(searchStoreActions.searchStore(req));
  }, [filter, dispatch]);

  const commonStoreList =
    budgetStoreList.length > 0
      ? storeList.filter((data) =>
          budgetStoreList.some((budgetData) => budgetData.Name === data.Name)
        )
      : storeList;

  if (!isLoading && (!commonStoreList || commonStoreList.length === 0)) {
    return (
      <Box
        height="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography fontWeight="bold" variant="h5" paddingTop="10px">
            レストランが見つかりませんでした
          </Typography>
          <Typography sx={{ py: 5 }}>
            条件を変更して再度検索してください
          </Typography>
          <Button
            variant="outlined"
            onClick={() => {
              dispatch(searchStoreActions.resetFilter());
            }}
          >
            検索条件をリセットする
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box borderBottom={1} borderColor="divider">
        <Tabs value={filter.sort_code} onChange={handleToggleChange}>
          <Tab key="point" value={0} label="ポイント" />
          <Tab key="reviews" value={1} label="クチコミ" />
        </Tabs>
      </Box>

      {isLoading ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width="100vw"
          height="100vh"
          py={10}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" px={2} py={1}>
          {commonStoreList &&
            commonStoreList.map((e) => <MStoreCard key={e.Name} {...e} />)}
        </Box>
      )}
    </Box>
  );
}
